'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var statusMsg = require('./side-panel-status-msg');

var addEventHandlers = function() {

	appDom.document
		.on('click', '.package-detail__add-image-to-package-btn', onAddImageToPackageBtnClicked)
		.on('click', '.package-detail__remove-image-from-package-btn', onRemoveImageFromPackageBtnClicked)
		.on('click', '.package-detail__edit-link', onEditLinkClicked);

};

var onEditLinkClicked = function(e) {

	e.preventDefault();

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: 'package_detail',
			detail: true
		}
	}).done(function(response) {

		sidePanel.open(response.markup);

	});

};

var onRemoveImageFromPackageBtnClicked = function(e) {

	var $link = $(this);
	var sizeId = $link.attr('data-size-id');
	var photoId = $link.attr('data-photo-id');
	var photoIndex = $link.attr('data-photo-idx');
	var itemKey = $link.attr('data-item-key');

	e.preventDefault();
	e.stopPropagation();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			photoId: photoId,
			photoIndex: photoIndex,
			sizeId: sizeId,
			itemKey: itemKey
		}
	}).done(function() {

		renderPackageImagesPanel(sizeId, false);

	});

};

var onAddImageToPackageBtnClicked = function(e) {

	var $link = $(this);
	var sizeId = $link.attr('data-size-id');
	var photoId = $link.attr('data-photo-id');
	var itemKey = $link.attr('data-item-key');
	var poseAddOn = $link.attr('data-pose-add-on');
	var printAddOn = $link.attr('data-print-add-on');

	e.preventDefault();

	$.ajax({
		url: $link.attr('data-href'),
		method: 'POST',
		dataType: 'JSON',
		data: {
			sizeId: sizeId,
			photoId: photoId,
			itemKey: itemKey,
			poseAddOn: poseAddOn,
			printAddOn: printAddOn
		}
	}).done(function(response) {

		if (response.status.code) {

			renderPackageImagesPanel(sizeId, true);

		} else {

			notify.show({
				target: $('.' + response.target),
				msg: response.status.msg
			});

		}

	});

};

var renderPackageImagesPanel = function(sizeId, addedToCart) {

	$.ajax({
		url: '?page=buy_panel',
		method: 'POST',
		dataType: 'JSON',
		data: {
			activePanel: 'package_images'
		}
	}).done(function(response) {

		sidePanel.open(response.markup, {retainScrollPosition: true});

		if (addedToCart) {
			statusMsg.show('added_to_cart');
		}

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
